<template>
  <a-layout-sider
    :collapsed="isCollapsed"
    :trigger="null"
    collapsible
    width="210"
    style=""
    class="fixed-sider sider-shadow"
    theme="dark"
  >
    <div
      style="height: 64px;padding: 16px 10px 16px 24px;"
      class="flex-j-b flex-a-c b-box logo-bg-color"
    >
      <img :src="Logo" alt="logo" width="32" height="32" />
      <div
        class="bold white animate__animated animate__backInLeft"
        style="font-size:12px;width:135px;"
        v-if="!isCollapsed"
      >
        {{ title }}
      </div>
    </div>
    <a-menu
      theme="dark"
      mode="inline"
      @click="handleClick"
      :selectedKeys="selectedKeys"
      :openKeys.sync="openKeys"
    >
      <template v-for="route of addRoutes[0].children">
        <template v-if="!route.children">
          <a-menu-item :key="route.path" v-if="!route.hidden">
            <a-icon v-if="route.meta.icon" :type="route.meta.icon" />
            <span>{{ route.meta.title }}</span>
          </a-menu-item>
        </template>
        <template v-else>
          <!-- 不隐藏 -->
          <template v-if="!route.hidden">
            <!-- 显示成menu-item -->
            <template v-if="route.hideChildrenInMenu">
              <a-menu-item :key="route.path">
                <a-icon v-if="route.meta.icon" :type="route.meta.icon" />
                <span>{{ route.meta.title }}</span>
              </a-menu-item>
            </template>
            <template v-else>
              <sub-menu :key="route.path" :route="route"></sub-menu>
            </template>
          </template>
          <!-- 隐藏 子菜单全没-->
          <template v-else> </template>
        </template>
      </template>
    </a-menu>
  </a-layout-sider>
</template>

<script>
import { mapGetters } from "vuex";
import SubMenu from "@/components/Menu/Index";
import EyeLogo from "@/assets/logo-eye.png";
// import SimqLogo from "@/assets/logo-simq.png";

export default {
  components: {
    SubMenu
  },
  data() {
    return {
      Logo: null,
      title: "",
      selectedKeys: [this.$route.path],
      openKeys: []
    };
  },
  computed: {
    ...mapGetters(["isCollapsed", "addRoutes", "isMobile"])
  },
  watch: {
    $route: function(newValue) {
      this.selectedKeys = [newValue.path];
      this.calcOpenKeys();
    }
  },
  methods: {
    handleClick({ key }) {
      this.$router.push(key);
    },
    calcOpenKeys() {
      const paths = this.$route.matched.slice(
        1,
        this.$route.matched.length - 1
      );
      paths.forEach(element => {
        if (!this.openKeys.includes(element.path)) {
          this.openKeys.push(element.path);
        }
      });
    },
    _getLogoAndTitle() {
      if (process.env.VUE_APP_PROJECT_NAME === "all") {
        this.title = "国家基层儿童青少年近视防控人员培训管理系统";
        this.Logo = EyeLogo;
      } else if (process.env.VUE_APP_PROJECT_NAME === "eye") {
        this.title = "国家基层儿童青少年近视防控人员培训管理系统";
        this.Logo = EyeLogo;
      }
    }
  },
  created() {
    this.calcOpenKeys();
    this._getLogoAndTitle();
  }
};
</script>
<style lang="less" scoped>
.sider-shadow {
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}
.fixed-sider {
  position: fixed;
  left: 0;
  bottom: 0;
  top: 0;
  overflow: auto;
  z-index: 999;
  // 覆盖默认的滚动条
  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: hsla(0, 0%, 53%, 0.4);
  }
}
</style>
